import {jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const Menu = ({className, ...props}) => (
  _jsx('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: 
    _jsx('path', { d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z" ,} )
  })
)

export default Menu
